import MedicalServicesChart from './MedicalServicesChart';
import NonMedicalServicesChart from './NonMedicalServicesChart';
import RevenueByServiceChart from './RevenueByServiceChart';
import SummaryCards from './SummaryCards';

function Main() {
  return (
    <div className="App">
      <div style={{ padding: '30px', background: '#f8f9fb' }}>
        <SummaryCards />
      </div>
      <RevenueByServiceChart />
      <div className="container">
        <div className="header" style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '20px' }}>
          <div className="toggle" style={{ display: 'flex', gap: '8px' }}>

          </div>
        </div>

        <div className="charts" style={{ display: 'flex', gap: '20px' }}>
          <div style={{ flex: 1 }}>
            <MedicalServicesChart />
          </div>
          <div style={{ flex: 1 }}>
            <NonMedicalServicesChart />
          </div>
        </div>
      </div>
      {/* <div style={{ padding: '30px 0px', background: '#f9fafc', }}>

      </div>
      <div style={{ padding: '30px 0px', background: '#f9fafc', }}>
      </div>
      <div style={{ padding: '30px 0px', background: '#f9fafc', }}>

      </div> */}
    </div>
  );
}

export default Main;
